import s from './Common.module.scss';

const BtnLoader = () => {
  return <div className={s.btnLoader}></div>;
};

export default BtnLoader;
